import {axios} from '../Api';

class EditHistoryService {
    persistEdit = (payload) => {
        return axios.post('/app/api/edits', payload);
    };

    persistHidden = (hidden, uuids) => {
        return axios.put(`/app/api/edits/toggleHidden?hidden=${hidden}`, uuids);
    };

    persistDelete = (deleteFlag, permanent, uuids) => {
        return axios.put(`/app/api/edits/toggleDelete?delete=${deleteFlag}${permanent ? '&permanent=true' : ''}`, uuids);
    };
}

export default new EditHistoryService();



// WEBPACK FOOTER //
// ./src/services/EditHistoryService.js